<template>
    <div class="full-screen-view" :style="viewStyle">
        <NormalHeader
            :returnLabel="label"
            :useChatBtn="false"
            :useReturnBtn="false"
        />

        <div class="login-view-box">
            <div class="content-box">
                <LoginComponent
                    :autoLogin="false"
                    :viewPart="defaultView"
                    @login-check-complete="loginCheck"
                />
            </div>
        </div>
    </div>


</template>

<script setup>

import NormalHeader from "@/components/shopopee/pageHeader/normalHeader.vue";
import LoginComponent from "@/components/loginComponent.vue";
import {inject, getCurrentInstance, ref, computed, toRef, onBeforeMount} from "vue";
import {usePageinfo} from "@/stores/pageinfo";
import myUtil from "@/util/util";
import {useUserinfo} from "@/stores/userinfo";
import cookie from "@/util/cookie";

const { proxy } = getCurrentInstance()
const i18n = inject("i18n")
const pageInfoRef = toRef(usePageinfo())
const userInfoRef = toRef(useUserinfo())
let pageJson = {}

const defaultView = ref("login")

const viewStyle = ref({
    width: window.innerWidth + "px",
    height: window.innerHeight + "px"
})

const label = computed(() => {
    // return i18n.tkey("lang_login_in")
    return "3DShopopee"
})

function loginCheck(stats){

  var goto = getGotoUrl(window.location.search)
  //console.log(goto)
    if (stats == -1){
      var urlStri = getUrlValue("loc")
      if(!myUtil.isEmpty(urlStri)&& urlStri.includes("productInfo")){
        window.location.href=`${proxy.$ShopopeeUrl}${goto}`
      }else {

        proxy.$router.push({name: "demoIndex2"})

        cookie.setCookie("logined", true, {path: '/'})
      }
    }else{
        console.log(i18n.tkey("lang_request_error"))
    }
}
function getGotoUrl(url){
  var loc = null
  var varName = null
  var value = null
  loc = getUrlValue("loc", url)
  varName = getUrlValue("varName", url)
  value = getUrlValue("value", url)

  if (myUtil.isEmpty(loc) || (!myUtil.isEmpty(varName) && myUtil.isEmpty(value)))
    return null

  var goto = ""
  if (loc.indexOf("--") != -1){
    var path = loc.split("--")
    path.forEach(function (value ,index) {
      goto += "/" + value
    })

    if (!myUtil.isEmpty(varName)){
      goto += "?" + varName + "=" + value
    }
  }else{
    goto = loc
    if (!myUtil.isEmpty(varName)){
      goto += "?" + varName + "=" + value
    }
  }
  return goto
}
function getUrlValue(value, url) {
  if (myUtil.isEmpty(url))
    url = window.location.search
  var varName = value
  var reg = new RegExp("(^|&)" + varName + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
  var values = url.substr(1).match(reg);
  if (null == values || "" == values || undefined == values){
    return null
  }else{
    return values[2]
  }
}

onBeforeMount(() => {
    pageJson = pageInfoRef.value.infoJson
    pageInfoRef.value.infoJson = null

    let lang = myUtil.getUrlValue("lang")

    if (myUtil.isNotEmpty(lang)){
        lang = lang.toLowerCase()
        if (lang === "zh"){
            userInfoRef.value.lang = "zh"
        }else if(lang === "en"){
            userInfoRef.value.lang = "en"
        }
    }

    if (myUtil.getUrlValue("operation") === "signup"){
        defaultView.value = "signup"
    }

})

</script>

<style scoped>
    .login-view-box {
        width: 100%;
        height: 800px;
        overflow-x: hidden;
        overflow-y: auto;
        padding-bottom: 35px;
        box-sizing: border-box;
    }

    @media screen and ( min-width: 576px ) {
        .content-box {
            width: 560px;
            height: 100%;
            margin: auto;
        }
    }

    @media screen and ( max-width: 500px ) {
        .content-box {
            width: 90%;
            height: 100%;
            margin: auto;
        }
    }

    .full-screen-view {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        overflow-y: auto;
        overflow-x: hidden;
    }

</style>